module.exports = __webpack_public_path__ + "img/public-health.b5e1a32b.png";